import React from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from '@/components/atoms/Modal';
import { Button } from '@/components/atoms/Button';

type Props = {
    isOpen: boolean;
    sourceName: string;
    droppedLinkType: 'product' | 'category';
    onDismiss: () => void;
};

export const DuplicateFallbackModal: React.FC<Props> = ({ isOpen, sourceName, droppedLinkType, onDismiss }) => {
    const messageKey =
        droppedLinkType === 'product'
            ? 'promotionalBanner.duplicate.fallback.product'
            : 'promotionalBanner.duplicate.fallback.category';

    const buttons = (
        <Button buttonType="primary" onClick={onDismiss}>
            <FormattedMessage id="promotionalBanner.duplicate.fallback.dismiss" />
        </Button>
    );

    return (
        <Modal isOpen={isOpen} onHide={onDismiss} title="promotionalBanner.duplicate.fallback.title" buttons={buttons}>
            <FormattedMessage id={messageKey} values={{ sourceName }} />
        </Modal>
    );
};
